export default {
    'name': 'check',
    'width': '12',
    'height': '12',
    'viewBox': '0 0 12 12',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M10.4785 3.72881C10.6738 3.53355 10.6738 3.21697 10.4786 3.0217C10.2833 2.82643 9.96672 2.82643 9.77145 3.02168L4.87499 7.91793L2.60354 5.64668C2.40827 5.45142 2.09168 5.45144 1.89643 5.64671C1.70118 5.84198 1.70119 6.15856 1.89646 6.35381L4.52146 8.97858C4.71672 9.17382 5.03329 9.17382 5.22855 8.97857L10.4785 3.72881Z\' fill=\'#42A463\'/>'
}
